'use client';

import { createWithEqualityFn } from 'zustand/traditional';
import { persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { applyDevtools } from './storeUtils';
import { IAccountSummary } from '@/types/types';
import { config } from '@/config';

export interface IBadgeDetails {
    surveyQty: number | undefined;
    referralQty: number | undefined | null;
    hasProfileIcon: boolean | undefined;
    hasAccountIcon: boolean | undefined;
    hasWalletIcon: boolean | undefined;
    hasTaxDetailsIcon?: boolean | undefined;
}
export interface AccountState extends Partial<IAccountSummary> {
    updateSummary: (data: Partial<IAccountSummary>) => void;
    reset: () => void;
}

const initialState: Partial<IAccountSummary> = {
    surveys: undefined,
    referrals: null,
    hasProfileQuestions: false,
    isEmailConfirmed: true,
    isVerificationRequired: false,
    marketResearchInd: false,
    walletBalance: undefined,
    preferredLanguageId: undefined,
    countryCode: undefined,
    isTaxableHonorariaThreshold: false,
    notifications: undefined,
    subpanelName: null,
    subpanelId: null,
    expertNetworkStatus: undefined,
    createDt: undefined,
};

export const useAccountStore = createWithEqualityFn<AccountState>()(
    persist(
        applyDevtools(
            (set) => ({
                ...initialState,
                updateSummary: (data: Partial<IAccountSummary>) => {
                    set(
                        (state) => ({ ...state, ...data }),
                        false,
                        'Update account store with data provided',
                    );
                },
                reset: () => {
                    set(initialState, false, 'Resetting summary state');
                },
            }),
            { name: `MPW ${config.theme} Account Store` },
        ),
        {
            name: `mpw-${config.theme}-account-storage`,
        },
    ),
    shallow,
);
